<template>
  <div class="detail-contanier light-bg" ref="detailContain">
    <titleHeader title="订单详情"></titleHeader>
    <!--订单状态-->
    <div class="order-status-box" v-show="orderData.orderInfoVo.orderStatus">{{orderData.orderInfoVo.orderStatus | getStatus}}</div>
    <!--收货地址-->
    <div class="order-address" v-show="orderData.orderAddressVo.name">
      <van-icon name="location-o" size="22"/>
      <div class="address-info">
        <div class="address-username">
          <span>{{orderData.orderAddressVo.name}}</span>
          <span>{{orderData.orderAddressVo.tel}}</span>
        </div>
        <div class="address-detail">
          <span>{{orderData.orderAddressVo.addressDetail}}</span>
        </div>
      </div>
    </div>
    <!--商品列表-->
    <div class="supplier-list">
      <div class="supplier-item" >
<!-- 供应商信息 -->
        <div class="supplier">
          <div class="supplier-name">
            <i class="iconfont icon-gongyingshang" style="margin-right: 5px"></i>
            {{supplier.name}}
          </div>
          <div class="goods-num">
            共计{{supplier.sum}}件商品
          </div>
        </div>
<!--商品信息-->
        <div class="goods-list">
          <div class="goods-item clearfix" v-for="(goods, $index) in goodsList" :key="$index">
            <div class="item-box" @click="gotoGoods(goods)">
              <div class="image-box">
                <img v-bind:src="goods.picUrl" alt="">
              </div>
              <div class="goods-info">
                <!--商品名称-->
                <div class="over2line">{{goods.goodsName}}</div>
                <!--商品规格-->
                <div class="goods-standard">{{goods.specificationNames}}</div>
                <div>
                  <goodsPrice :price="goods.subTotalPrice" :main-size="14" style="display: inline-block;"></goodsPrice>
                  <span class="goods-num"> × {{goods.num}} </span>
                </div>
              </div>
            </div>
            <self-button type="primary" class="self-btn" v-show="goods" @on-click="gotoReturns(goods)">退/换货</self-button>
          </div>
        </div>
      </div>
    </div>
<!--订单信息-->
    <div class="order-info" v-show="orderData.orderInfoVo.orderStatus">
      <div>
        <span class="info-label">订单编号：</span>
        <span class="info-content">{{orderData.orderInfoVo.orderSn}}</span>
      </div>
      <div>
        <span class="info-label">下单时间：</span>
        <span class="info-content">{{orderData.orderInfoVo.addTime}}</span>
      </div>
    </div>
    <!--底部按钮-->
    <div class="bottom-btn" ref="bottomBtn">
      <self-button type="default" class="buy-again" @on-click="buyAgain()" v-show="orderData.orderInfoVo.orderStatus != 1">再次购买</self-button>
      <self-button type="default" class="buy-again" @on-click="gotoPay(orderData.orderInfoVo.orderSn)" v-show="orderData.orderInfoVo.orderStatus == 1">去支付</self-button>
    </div>
    <van-loading class="data-loading" color="#45C5DA" v-show="display.showLoading" />
  </div>
</template>

<script>
  import api from 'api/user';
  import {orderStatus} from 'common/js/commonVariables';
  import gotopay from "common/js/mixin/gotopay";
  export default {
    mixins: [gotopay],
    data() {
      return {
        display:{
          showLoading:false
        },
        page: {
          pageSize: 5,
          pageNumber: 1,
        },
        orderData:{
          //根据后台返回的格式设置的
          orderAddressVo:{},
          orderInfoVo:{},
          masterOrderGoodsVoPage:{},
        },
        goodsList:[],//商品列表
        supplier: {}, //供应商信息
      };
    },
    created() {
      // console.log(this.$route.query.orderSn);
      this.display.showLoading = true;
      this.getOrderDetailData();
    },
    mounted(){
      const bottomHeight = this.$refs.bottomBtn.offsetHeight;
      this.$refs['detailContain'].style.height = window.innerHeight - bottomHeight + 'px';
    },
    methods: {
      async getOrderDetailData() {
        let params = {
          orderSn: this.$route.query.orderSn,
        };
        const data = await api.getOrderDetail(params);
        this.display.showLoading = false;
        this.orderData = data;
        const goods = this.orderData.orderGoodsVoPage.records;
        if (goods && goods.length > 0) {
          this.goodsList = goods;
          this.supplier.sum = 0;
          //获取各供应商下商品数量
          this.goodsList.map(item=>{
            this.supplier.sum += item.num;
          })
          this.supplier.name = this.goodsList[0].supplierName;
        }
      },
      //再次购买
      async buyAgain(){
        let params = [];
        this.goodsList.map(item=>{
          params.push({
            num: item.num,
            productId: item.productId,
          })
        })
        await api.saveCart(params);
        this.$router.push({
          name:'shopCart'
        })
      },
      //前往评价
      gotoEvaluate(){
        const goodsList = this.goodsList.map(goods=>{
          return {
            goodsName: goods.goodsName,
            picUrl: goods.picUrl,
            productId: goods.productId,
            goodsId: goods.goodsId
          }
        })
        this.$router.push({
          path:'/evaluate',
          query: {
            goodsList: JSON.stringify(goodsList)
          }
        })
      },
      //前往退换货
      gotoReturns(item) {
        this.$router.push({
          path:'/returns',
          query: {
            goodsDetail: JSON.stringify(item),
            orderInfo: JSON.stringify(this.orderData.orderInfoVo)
          }
        })
      },
      //前往商品详情
      gotoGoods(goods) {
        console.log(goods);
        this.$router.push({
          path: '/goods-detail',
          query: {from: 'order',goodsId: goods.goodsId}
        })
      }
    },
    filters:{
      getStatus(status){
        return orderStatus[status]
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .detail-contanier{
    overflow: auto;
    .order-status-box{
      padding: 22px 10px;
      background: $theme-color;
      color: #fff;
    }
    //收货地址
    .order-address{
      display: flex;
      padding: 10px;
      margin-bottom: 15px;
      background: #fff;
      align-items: center;
      .address-info{
        display: flex;
        margin-left: 10px;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        color: $weight-word-color;
        .address-detail{
          font-size: 13px;
          color: $lingt-word-color;
        }
      }
    }
    //商品列表
    .supplier-list{
      .supplier-item{
        margin-bottom: 15px;
        background: #fff;
        color: $weight-word-color;
        .supplier{
          display: flex;
          padding: 10px;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid $light-line-color;
          .goods-num{
            color: $lingt-word-color;
            font-size: 12px;
          }
        }
        .goods-item{
          padding: 10px;
          .item-box{
            display: flex;
            .image-box{
              width: 75px;
              height: 75px;
              margin-right: 15px;
              img{
                display: inline-block;
                width: 100%;
                height: 100%;
              }
            }
            .goods-info{
              display: flex;
              flex: 1;
              flex-direction: column;
              justify-content: space-around;
              .goods-standard,.goods-num{
                font-size: 12px;
                color: $light-color;
              }
              .goods-num{
                float: right;
              }
            }
          }
          .self-btn{
            float: right;
          }
        }
      }
    }
    //订单信息
    .order-info{
      padding: 10px;
      font-size: 14px;
      background: #fff;
      .info-label{
        color: $light-color;
      }
    }
    //底部按钮
    .bottom-btn{
      position: fixed;
      display: flex;
      bottom: 0;
      left: 0;
      width: 100vw;
      height: 50px;
      flex-direction: row-reverse;
      align-items: center;
      box-shadow: 0 -2px 4px 0 rgba(0,0,0,.07);
      .buy-again{
        margin: 0 10px;
      }
    }
  }
</style>
